var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"content-class":"popover-content","bottom":!_vm.isHorizontal,"right":_vm.isHorizontal,"trigger":"click","offset-y":!_vm.isHorizontal,"offset-x":_vm.isHorizontal,"z-index":20,"close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_vm._t("activator",null,{"on":on,"attrs":attrs})]}}],null,true)},[_c('v-main',{staticClass:"wrapper"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }